/**
 * National Recovery and Resilience Plan — frontend behaviour.
 *
 * Blur-reveal the header, stagger the cards in, and sweep each card's lime bar
 * left→right on entrance (and re-sweep on hover — same motion language as the
 * Deliverables block). The project line and download rows fade in after.
 * Loaded as an ES module only on pages where this block renders.
 */
import './style.scss';
import { gsap } from 'gsap';

function init() {
	const sections = document.querySelectorAll('[data-nrrp]');
	if (!sections.length) return;

	const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

	sections.forEach((section) => {
		const head = Array.from(section.querySelectorAll('[data-nrrp-anim]'));
		const cards = Array.from(section.querySelectorAll('[data-nrrp-card]'));
		const bars = Array.from(section.querySelectorAll('[data-nrrp-bar]'));
		const rows = Array.from(section.querySelectorAll('[data-nrrp-row]'));
		const targets = [...head, ...cards, ...rows];
		if (!targets.length) return;

		if (reduced) {
			targets.forEach((el) => { el.style.opacity = '1'; el.style.filter = 'none'; el.style.transform = 'none'; });
			bars.forEach((bar) => { bar.style.transform = 'none'; });
			return;
		}

		gsap.set(head, { opacity: 0, y: 20, filter: 'blur(10px)' });
		gsap.set(cards, { opacity: 0, y: 28, filter: 'blur(12px)' });
		gsap.set(rows, { opacity: 0, y: 20, filter: 'blur(10px)' });
		gsap.set(bars, { scaleX: 0 });

		const play = () => {
			const tl = gsap.timeline({ defaults: { ease: 'power3.out' } });

			tl.to(head, { opacity: 1, y: 0, filter: 'blur(0px)', duration: 0.8, stagger: 0.1 }, 0.1);

			const cardsStart = 0.3;
			// clearProps:transform so GSAP's leftover inline transform doesn't
			// override the CSS :hover lift.
			tl.to(cards, { opacity: 1, y: 0, filter: 'blur(0px)', duration: 0.8, stagger: 0.12, clearProps: 'transform' }, cardsStart);
			tl.to(bars, { scaleX: 1, duration: 0.6, ease: 'power2.out', stagger: 0.12 }, cardsStart + 0.2);
			tl.to(rows, { opacity: 1, y: 0, filter: 'blur(0px)', duration: 0.7, stagger: 0.1 }, cardsStart + 0.4);
		};

		// Re-fill a card's bar on hover (same left→right sweep as entrance).
		cards.forEach((card) => {
			const bar = card.querySelector('[data-nrrp-bar]');
			if (!bar) return;
			card.addEventListener('mouseenter', () => {
				gsap.fromTo(
					bar,
					{ scaleX: 0 },
					{ scaleX: 1, duration: 0.5, ease: 'power2.out', overwrite: true }
				);
			});
		});

		const io = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				if (!entry.isIntersecting) return;
				io.unobserve(entry.target);
				play();
			});
		}, { rootMargin: '0px 0px -15% 0px', threshold: 0.1 });

		io.observe(section);
	});
}

if (document.readyState !== 'loading') init();
else document.addEventListener('DOMContentLoaded', init);
